import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Add x-company-id header for multi-company admin
    const currentCompanyId = localStorage.getItem('current_company_id');
    if (currentCompanyId) {
      config.headers['x-company-id'] = currentCompanyId;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // ตรวจสอบว่าไม่ใช่การ request จากหน้า login
      const isLoginRequest = error.config && error.config.url && error.config.url.includes('/auth/login');
      
      if (!isLoginRequest) {
        localStorage.removeItem('auth_token');
        const basePath = process.env.PUBLIC_URL || '';
        window.location.href = basePath + '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;